<div id="utf-auth-single-id-screen">
  <div class="row no-gutters">
    <div class="col-lg-4" id="progresstracker">
      <app-progress-tracker [stepOneIcon]="stepOneIcon" [stepOneTickIcon]="stepOneTickIcon" [stepOneDone]="stepOneDone"
        [stepTwoInformationpage]="stepTwoInformationpage" [stepTwoProfileDone]="stepTwoProfileDone"
        [stepTwoDone]="stepTwoDone" [progressTrackerStatus]="progressTrackerStatus"
        (progressTrackerEvent)="handleProgressTrackerEvent($event)"></app-progress-tracker>
    </div>
    <div class="col-lg-8" id="form-component-section">
      <app-utf-auth-single-id-homepage></app-utf-auth-single-id-homepage>
    </div>
  </div>
</div>